import { login, logout, sendResetPasswordCode, resetPassword } from "@/api/auth";
import store from "@/store";

// Handles user login
export const Login = (commit, payload) => {
  return new Promise((resolve) => {
    login(payload).then((response) => {
      
      if (response.status_code == 200) {
        store.commit("auth/login", response.data);
        resolve("success");
      }
    })
  });
};

// Handles user logout
export const Logout = () => {
  return new Promise((resolve) => {
    logout().then((response) => {
      
      if (response.status_code == 200) {
        store.commit("auth/logout");
        resolve("success");
      }
    })
  });
};

// Handles send code for password reset
export const SendResetPasswordCode = (commit, payload) => {
  return new Promise((resolve) => {
    sendResetPasswordCode(payload).then((response) => {
      if (response.status_code == 201) {
        store.commit("auth/setEmail", response.data.email);
        store.commit("shared/setSuccessResponse", response.data.message);

        resolve("success");
      }
    })
  });
};

// Handles reset user password
export const ResetPassword = (commit, payload) => {
  return new Promise((resolve) => {
    resetPassword(payload).then((response) => {
      if (response.status_code == 201) {
        store.commit("shared/setSuccessResponse", response.data.message);
        
        resolve("success");
      }
    })
  });
};
